import { getHubAndTierFromApiName } from '../../ums/utils';
export const getOwnedHubsAndSuiteApiNames = ownedProducts => {
  const ownedHubsAndSuiteApiNames = [];
  for (const ownedProduct of ownedProducts) {
    const {
      productLine,
      productApiName
    } = ownedProduct;
    const {
      hub
    } = getHubAndTierFromApiName(productApiName);
    const isCrmSuite = hub === 'suite';
    if (productLine || isCrmSuite) {
      ownedHubsAndSuiteApiNames.push(productApiName);
    }
  }
  return ownedHubsAndSuiteApiNames;
};